module.exports = __webpack_public_path__ + "img/penciledit.7d1c8419.svg";